import { z, ZodTypeAny, ZodObject, ZodString } from "zod";

// Recursive function to apply default empty string to all string fields
export function applyDefaultToStrings<T extends ZodTypeAny>(
  schema: T,
  defaultValue: string | undefined = ""
): T {
  if (schema instanceof ZodString) {
    return schema.default(defaultValue) as unknown as T;
  }

  if (schema instanceof ZodObject) {
    const shape = schema.shape;
    const newShape: Record<string, ZodTypeAny> = {};

    for (const key in shape) {
      if (Object.prototype.hasOwnProperty.call(shape, key)) {
        newShape[key] = applyDefaultToStrings(shape[key], defaultValue);
      }
    }

    return z.object(newShape) as unknown as T;
  }

  return schema;
}
